module.exports = __webpack_public_path__ + "img/delivery-status-normal.a24ea493.svg";